<div class="grid">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoListar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoListar">
			<div class="formgroup" *ngIf="permissaoInserir">
				<div class="p-fluid p-formgrid grid">
					<div class="field col-12 md:col-2">
						<button pButton pRipple routerLink="/apps/pagamento-despesa/inserir" label="Novo"
							icon="pi pi-plus" class="p-button-outlined sm:w-9rem"></button>
					</div>
				</div>
			</div>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="pagamentosDespesas" dataKey="id" [rows]="10" [loading]="loading" [rowHover]="true"
				[paginator]="true" [globalFilterFields]="['planoContaEmpresa.descricao', 'identificacao']"
				responsiveLayout="stack" styleClass=" p-datatable-sm">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<div class="flex flex-column sm:flex-row w-full">
							<div class="p-fluid w-full mr-2 sm:w-auto">
								<label htmlFor="filtroCompetencia">Vencimento</label>
								<p-dropdown [options]="filtroMesesPagamentos" emptyFilterMessage="Nenhum registro"
									name="filtroCompetencia" ngModel #caixas="ngModel" emptyMessage="Nenhum registro"
									[(ngModel)]="filtroMesSelecionado" (onChange)="recarregarDados()">
								</p-dropdown>
							</div>
							<div class="p-fluid w-full mr-2 sm:w-auto mt-2 sm:mt-0">
								<label for="">Status</label>
								<p-dropdown [options]="filtros" optionLabel="label" optionValue="value"
									emptyFilterMessage="Nenhum registro" name="filtro" ngModel #filtro="ngModel"
									(onChange)="recarregarDados()" [(ngModel)]="filtroSelecionado">
								</p-dropdown>
							</div>
						</div>
						<div class="flex justify-content-end flex-column sm:flex-row">
							<div class="p-inputgroup p-fluid w-full sm:w-auto">
								<div class="flex w-full sm:w-auto mt-3 sm:mt-4">
									<span class="p-input-icon-left">
										<i class="pi pi-search"></i>
										<input pInputText type="text" #filter (input)="buscar(dt1, $event)"
											placeholder="Buscar" class="w-full" />
									</span>
									<span class="ml-2">
										<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
											pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
									</span>
								</div>

							</div>

						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="dataVencimento">
							Vencimento
							<p-sortIcon field="dataVencimento">
							</p-sortIcon>
						</th>
						<th pSortableColumn="planoContaEmpresa.descricao">
							Especificação
							<p-sortIcon field="planoContaEmpresa.descricao">
							</p-sortIcon>
						</th>
						<th pSortableColumn="identificacao">
							Identificação
							<p-sortIcon field="identificacao">
							</p-sortIcon>
						</th>
						<th pSortableColumn="valorFluxo">
							Valor Despesa
							<p-sortIcon field="valorFluxo">
							</p-sortIcon>
						</th>
						<th>
							Status
						</th>


						<th style="text-align: center;">
							<div>
								Ações
							</div>
						</th>

					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td>
							{{ item.dataVencimento | date: 'dd/MM/yyyy'}}
						</td>
						<td>
							{{ item.planoContaEmpresa.descricao }}
						</td>
						<td>
							{{ item.identificacao }}
						</td>
						<td>
							{{ item.valorFluxo | currency: 'BRL':'symbol':'1.2-2'}}
						</td>

						<td>
							<span class="product-badge status-outofstock" style="white-space: nowrap;"
								*ngIf="item.status === 0">A PAGAR</span>
							<span class="product-badge status-instock" *ngIf="item.status === 1">PAGO</span>
							<span class="customer-badge status-renewal" *ngIf="item.status === 2">AGENDADO</span>
							<span class="product-badge status-lowstock" *ngIf="item.status === 3">ESTORNADO</span>
						</td>

						<td style="text-align: center;">
							<div>
								<button *ngIf="permissaoEstornar && item.status === 1"
									pButton pRipple pTooltip="Estornar" icon="pi pi-replay" (click)="estornarDespesa(item)"
									class="p-button-info mr-2 mb-2 sm"></button>
								<button *ngIf="permissaoDetalhar" pButton pRipple
									pTooltip="Detalhar" (click)="detalharDespesa(item.id)" icon="pi pi-eye"
									class="p-button-info mr-2 mb-2"></button>
								<button *ngIf="permissaoPagar && !(item.status === 1)"
									pButton pRipple pTooltip="Pagar" (click)="pagarDespesa(item.id)" icon="pi pi-dollar"
									class="p-button-success mr-2 mb-2"></button>
								<button *ngIf="permissaoExcluir" pButton pRipple
									pTooltip="Excluir" icon="pi pi-trash" (click)="excluirDespesa(item.id)"
									class="p-button-danger mr-2 mb-2 sm"></button>
							</div>
						</td>

					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando. Por favor aguarde.</td>
					</tr>
				</ng-template>
			</p-table>
			<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
		</div>
	</div>
</div>